const moment = require("moment/moment");

let templateTrafTypeFormatter = {
  methods: {
    trafficType(row) {
      return TRAFFIC_TYPES[row.traffic_type] || "Не определен"
    },
    lastMonthCounter(row) {
      let lastCounter = (row.counters.sort((c1, c2) => moment(c2.month, "MM.YYYY").valueOf() - moment(c1.month, "MM.YYYY").valueOf()) || [])[0] || {counter: 0}
      if (!lastCounter.month) return "0"
      if (lastCounter.month !== moment().format("MM.YYYY")) return `${lastCounter.counter} (${lastCounter.month})`
      return lastCounter.counter
    },
  }
}

module.exports = templateTrafTypeFormatter